import { SET_OWNVENUE_CATEGORY } from '../actions';

const cateringownvenuecategory = (state = [], action) => {
  switch (action.type) {
    case SET_OWNVENUE_CATEGORY:
      return [...action.value];
    default: return state;
  }
}

export default cateringownvenuecategory;